import { Routes } from '@angular/router';
import { LoginComponent } from './core/auth/login/login.component';
import { authGuard } from './core/auth/guards/auth.guard';
import { FileUploadComponent } from './common/file/file-upload/file-upload.component';
import { FileUploadDragdropComponent } from './common/file/file-upload-dragdrop/file-upload-dragdrop.component';
import { FileDownloadComponent } from './common/file/file-download/file-download.component';
import { CustomerListComponent } from './feature/customer/customer-list/customer-list.component';
import { CustomerDetailsComponent } from './feature/customer/customer-details/customer-details.component';
import { VesselHubComponent } from './feature/vessel/component/vessel-hub/vessel-hub.component';
import { TrailHubComponent } from './feature/trail/component/trail-hub/trail-hub.component';
import { TestHubComponent } from './feature/test/component/test-hub/test-hub.component';
import { RecommendationHubComponent } from './feature/recommendation/component/recommendation-hub/recommendation-hub.component';
import { TestStepHubComponent } from './feature/test-step/component/test-step-hub/test-step-hub.component';
import { StepRecomHubComponent } from './feature/step-recom/component/step-recom-hub/step-recom-hub.component';

export const routes: Routes = [
    {path: 'login', component : LoginComponent},
    {path: '', redirectTo: 'login', pathMatch : 'full'},
    {path: 'adp', redirectTo: 'login', pathMatch : 'full'},
    {path: 'customers', component : CustomerListComponent, canActivate : [authGuard]},
    {path: 'customer-details', component : CustomerDetailsComponent, canActivate : [authGuard]},
    {path: 'vessel-hub', component : VesselHubComponent, canActivate : [authGuard]},
    {path: 'trail-hub', component : TrailHubComponent, canActivate : [authGuard]},
    {path: 'test-hub', component : TestHubComponent, canActivate : [authGuard]},
    {path: 'test-step-hub', component : TestStepHubComponent, canActivate : [authGuard]},
    {path: 'recommendation-hub', component : RecommendationHubComponent, canActivate : [authGuard]},
    {path: 'step-recom-hub', component : StepRecomHubComponent, canActivate : [authGuard]},
    {path: 'upload', component : FileUploadComponent, canActivate : [authGuard]},
    {path: 'file', component : FileUploadDragdropComponent, canActivate : [authGuard]},
    {path: 'download', component : FileDownloadComponent, canActivate : [authGuard]},
];
